import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../config/environments/environment';
import { Observable } from 'rxjs';
import { BookingParamsDto } from '../dtos/booking-params.dto';
import { Booking } from '../models/booking.interface';

@Injectable()
export class BookingsService {

  private readonly path = 'bookings';

  constructor(
    private readonly http: HttpClient
  ) { }

  findOne(params?: BookingParamsDto): Observable<Booking> {
    const url = `${environment.api.baseUrl}/${this.path}/one`;

    const httpParams = this.buildHttpParams(params);
    return this.http
      .get<Booking>(url, { params: httpParams })
      .pipe((response) => response);
  }

  findAll(params?: BookingParamsDto): Observable<Booking[]>{
    const url = `${environment.api.baseUrl}/${this.path}`

    const httpParams = this.buildHttpParams(params)
    return this.http
      .get<Booking[]>(url,{params: httpParams})
  }

  private buildHttpParams(params?: BookingParamsDto): HttpParams {
    let httpParams: any = {};

    if (params?.idShow) {
      httpParams.idShow = params?.idShow
    }
    if (params?.idUser) {
      httpParams.idUser = params?.idUser;
    }
    if(params?.status){
      httpParams.status = params.status
    }

    if (params?.status) {
      httpParams.status = params?.status;
    }

    return httpParams;
  }

}
